export default __webpack_public_path__ + "static/media/features-2.427a4d20.jpg";